import * as React from 'react';
import { PopularSearches } from './SearchHeaderBlocks/PopularSearches';

interface PopularSearchesBlockProps {
  settings?: {
    popular_searches_title?: string;
    popular_searches_list?: string;
    [key: string]: any;
  };
  className?: string;
}

export const PopularSearchesBlock: React.FC<PopularSearchesBlockProps> = ({ settings, className = '' }) => {

  const blockSettings = settings?.settings?.block_settings || settings || {};

  const popularSearches = blockSettings.popular_searches_list?.split(',').map((s) => s.trim()) || [];

  const handlePopularSearchClick = (search: string) => {
    window.location.href = `/search?q=${encodeURIComponent(search)}`;
  };

  return (
    <div className={`w-full ${className}`}>
      <PopularSearches
        title={blockSettings.popular_searches_title || 'Popular searches'}
        searches={popularSearches}
        onSearchClick={handlePopularSearchClick}
      />
    </div>
  );
};
